import Auth from '../../Helpers/auth';
const API_URL = process.env.REACT_APP_BACKEND_URL;

// GET: Fetches all discounts - protected route
async function httpGetDiscounts() {
  const token = Auth.getToken();
  try {
    let res = await fetch(`${API_URL}/discounts`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    const data = await res.json();
    return data;
  } catch (err) {
    return err;
  }
}
// GET: Fetches a single discount - protected route
async function httpGetSingleDiscount(discountId) {
  const token = Auth.getToken();
  try {
    let res = await fetch(`${API_URL}/discounts/${discountId}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    let data = await res.json();
    return data;
  } catch (err) {
    return err;
  }
}

// POST: Creates a discount - protected route
async function httpCreateDiscount(discount) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/discounts`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify(discount),
    });
  } catch (err) {
    return err;
  }
}

// PUT: Edits a discount - protected route
async function httpEditDiscount(discountId, discount) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/discounts/${discountId}`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify(discount),
    });
  } catch (err) {
    return err;
  }
}
// DELETE: Deletes a discount - protected route
async function httpDeleteDiscount(discountId) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/discounts/${discountId}`, {
      method: 'delete',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  } catch (err) {
    return err;
  }
}

// POST: Verfies a discount - protected route
async function httpVerifyDiscount(discountCode, companyId) {
  const token = Auth.getToken();
  try {
    return await fetch(`${API_URL}/discounts/verify`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ discountCode, companyId }),
    });
  } catch (err) {
    return err;
  }
}

export {
  httpCreateDiscount,
  httpGetDiscounts,
  httpGetSingleDiscount,
  httpEditDiscount,
  httpDeleteDiscount,
  httpVerifyDiscount,
};
